import axios from "axios";
const API_BASE_URL = process.env.REACT_APP_API_URL;

const axiosConfig = (token) => ({
  headers: {
    Authorization: `Bearer ${token}`,
  },
});

export const getListOrders = async (token, search, currentPage, sizePage) => {
  const apiUrl = search
    ? `${API_BASE_URL}/orders/admin/search/${search}/${currentPage}/${sizePage}`
    : `${API_BASE_URL}/orders/admin/${currentPage}/${sizePage}`;

  try {
    const response = await axios.get(apiUrl, axiosConfig(token));

    return response;
  } catch (error) {
    return error;
  }
};

export const getOrderById = async (token, id) => {
  const response = await axios.get(
    `${API_BASE_URL}/orders/admin/${id}`,
    axiosConfig(token)
  );

  try {
    return response;
  } catch (error) {
    return error;
  }
};

export const saveOrEditOrder = async (token, id, body) => {
  const apiUrl = id
    ? `${API_BASE_URL}/orders/update/${id}`
    : `${API_BASE_URL}/orders/create`;
  const method = id ? "put" : "post";
  const response = await axios[method](apiUrl, body, axiosConfig(token));
  try {
    return response;
  } catch (error) {
    return error;
  }
};

export const deleteOrder = async (token, id, body) => {
  const response = await axios.delete(`${API_BASE_URL}/orders/delete/${id}`, {
    headers: {
      Authorization: `Bearer ${token}`,
    },
    data: body,
  });
  try {
    return response;
  } catch (error) {
    return error;
  }
};
